import { TextCardConfig, CardData } from '../types'

interface TextProps {
  config: TextCardConfig
  data: CardData
}

export function Text({ data }: TextProps) {
  const primary = (data.primary as string[]) || []
  const secondary = data.secondary

  const isMultipleValues = primary.length > 1
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex flex-col gap-6">
        <div className="m-auto text-2xl font-bold">
          {isMultipleValues ? (
            <ul className="list-disc">
              {primary.map((li, i) => (
                <li key={i}>{li}</li>
              ))}
            </ul>
          ) : (
            primary[0]
          )}
        </div>
        {secondary && <div className="text-sm text-muted-foreground">{secondary}</div>}
      </div>
    </div>
  )
}
